import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE =
  "Malunjkar Engineering Company | Precision CNC Machining & Contract Manufacturing India";
const DEFAULT_DESCRIPTION =
  "ISO 9001:2015 certified precision contract manufacturer in Pune, India. CNC machining, sheet metal fabrication, heavy welding. ±0.005mm tolerance. Export to 30+ countries via FOB/CIF/DDP. Get a quote in 24 hours.";
const DEFAULT_KEYWORDS =
  "contract manufacturing India, CNC machining supplier, sheet metal fabrication, precision machining Pune, metal fabrication export, ISO 9001 manufacturer India, CNC laser cutting, press brake bending, MIG TIG welding services, OEM manufacturing India";
const DEFAULT_CANONICAL = "https://www.malunjkar.com";
const DEFAULT_OG_IMAGE = "https://www.malunjkar.com/og-image.jpg";

const organizationSchema = (description, canonical) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Malunjkar Engineering Company",
  url: canonical,
  logo: "https://www.malunjkar.com/logo.png",
  description,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Pune",
    addressRegion: "Maharashtra",
    addressCountry: "IN",
  },
  contactPoint: {
    "@type": "ContactPoint",
    email: "info@malunjkar.com",
    telephone: "+91-89998-73418",
    contactType: "customer service",
  },
});

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  canonical = DEFAULT_CANONICAL,
  ogImage = DEFAULT_OG_IMAGE,
  robots = "index, follow",
}) {
  const schema = organizationSchema(description, canonical);

  return (
    <Helmet>
      <html lang="en" />
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Malunjkar Engineering Company" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
